import { createTheme } from "@mui/material/styles";

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 12,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "filled",
        size: "small",
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        blurOnSelect: true,
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          "&:before, &:after": {
            display: "none",
          },
          border: "1px solid lightgrey",
          borderRadius: 5,

          fontWeight: 500,
          height: 40,
          minWidth: 250,
        },
      },
    },

    MuiChip: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          borderRadius: 2,
          fontWeight: "bold",
          fontSize: 9,
          padding: 8,
        },
        colorPrimary: {
          backgroundColor: "#a6e0fa",
          color: "#0f51fd",
        },
        colorSecondary: {
          backgroundColor: "#f0e0ff",
          color: "#a168d9",
        },
        colorSuccess: {
          backgroundColor: "#cbe8c7",
          color: "#30a221",
        },

        colorWarning: {
          backgroundColor: "#ffffb2",
          color: "#838305",
        },
        colorError: {
          backgroundColor: "#f9d9dc",
          color: "#db0621",
        },
      },
    },

    MuiButton: {
      defaultProps: {
        size: "small",
        disableElevation: true,
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          fontWeight: "bold",
          textTransform: "none",
          whiteSpace: "nowrap",
          paddingLeft: 20,
          paddingRight: 20,
        },
        containedPrimary: {
          backgroundColor: "#a6e0fa",
          "&:hover": {
            backgroundColor: "#a6e0fa",
          },
          color: "#0f51fd",
        },
        containedSuccess: {
          backgroundColor: "#bafbdf",
          "&:hover": {
            backgroundColor: "#bafbdf",
          },
          color: "#118785",
        },
        containedError: {
          backgroundColor: "#f9d9dc",
          "&:hover": {
            backgroundColor: "#f9d9dc",
          },
          color: "#db0621",
        },

        outlinedPrimary: {
          borderColor: "#0f51fd",
          color: "#0f51fd",
        },
        outlinedError: {
          borderColor: "#db0621",
          color: "#db0621",
        },
      },
    },

    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
        disableRipple: true,
      },
    },
  },
});

export default theme;
